<template>
  <FormKit
    ref="inputRef"
    v-bind="bindings"
    v-model="model"
    :testId="bindings.name || bindings.label || bindings.id"
    messagesClass="hidden"
    type="togglebuttons"
    enforced="true"
  >
    <template #label="context">
      <label v-if="context.label" :for="context.id" class="mb-4" :class="context.classes.label">{{
        context.label
      }}</label>
      <FormKitMessages class="!block" :node="(inputRef as any)?.node" />
    </template>
    <template #default="itemContext">
      <RadioCardListComparisonItem
        v-if="isComparisonItem && itemContext.option"
        v-bind="itemContext.option"
        :isSticky="isSticky"
        :isSelected="
          itemContext.option.__original !== undefined
            ? itemContext.option.__original === model
            : itemContext.option.value === model
        "
        :frequencyLabel="bindings.updatedFrequencyLabels ? bindings.updatedFrequencyLabels[itemContext.index] : ''"
        :amountSymbol="bindings.options?.[itemContext.index]?.amountSymbol ?? null"
        :prorataSymbol="bindings.options?.[itemContext.index]?.prorataSymbol ?? null"
        :marginLeftForAmountSymbol="bindings.marginLeftForAmountSymbol"
        :removeSpaceAfterProRataSymbol="bindings.removeSpaceAfterProRataSymbol"
      />
      <RadioCardListMegaItem
        v-else-if="itemContext.option"
        v-bind="itemContext.option"
        :isSelected="
          itemContext.option.__original !== undefined
            ? itemContext.option.__original === model
            : itemContext.option.value === model
        "
        :disabled="itemContext.disabled"
      />
    </template>
  </FormKit>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { FormKit, FormKitMessages } from '@formkit/vue';
import type { VueFormInputProps } from '@/composables/useFormInputData';
import RadioCardListMegaItem from './RadioCardListMegaItem.vue';
import RadioCardListComparisonItem from './RadioCardListComparisonItem.vue';

const props = defineProps<{
  bindings: VueFormInputProps;
}>();
const model = defineModel<string>();

const inputRef = ref(null);

const isComparisonItem = computed(() => {
  return props.bindings?.options?.some((option: any) => option.amount);
});

const isSticky = computed(() => {
  return props.bindings?.outerClass?.includes('sticky');
});
</script>
